// 环境配置管理
const config = {
  // 应用标题
  title: process.env.VUE_APP_TITLE || 'Vant Demo',
  
  // API基础URL
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL ,
  
  // 是否开启调试模式
  debug: process.env.VUE_APP_DEBUG === 'true',
  
  // 构建日期（多种格式）
  buildDate: process.env.VUE_APP_BUILD_DATE,
  buildDateISO: process.env.VUE_APP_BUILD_DATE_ISO,
  buildDateShort: process.env.VUE_APP_BUILD_DATE_SHORT,
  
  // 当前环境
  env: process.env.NODE_ENV,
  
  // 是否为开发环境
  isDev: process.env.NODE_ENV === 'development',
  
  // 是否为生产环境
  isProd: process.env.NODE_ENV === 'production'
}

export default config